import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import DetailProfile from '../../innerSection/CategoryProfile';
import useMicroSiteEncrypt from '../../CustomHook/useMicroSiteEncrypt';
import { IdleTimerProvider } from 'react-idle-timer';
import { eventTracking, fetchLeaderDetailData } from '../../../redux/actions/micrositeAction';
import CategoryDetails from '../../innerSection/CategoryDetails';
import CategoryList from '../../innerSection/CategoryList';
import LeadForm from '../../innerSection/LeadForm';
import FaqAccordion from '../../innerSection/FaqAccordion';
import BenefitCarousel from '../../carouselSection/BenefitCarousel';
import WhatsappButton from '../../innerSection/WhatsappButton';
import Disclaimer from '../../commonSection/Disclaimer';

const CategoryContainer = (props) => {
    const dispatch = useDispatch();
    const intervalRef = useRef(null);
    const initializedRef = useRef(false);
    const lastFetchRef = useRef({ id: null, time: 0 });
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const temp_id = searchParams.get('template_id');
    const id = searchParams.get('id');
    const { microSiteEncrypt } = useMicroSiteEncrypt();
    const theme_colors = useSelector((state) => state.microsite?.theme_colors);
    const profile_data = useSelector((state) => state.microsite?.profile_data);
    const new_microsite_extra_clt = useSelector((state) => state.microsite?.home_data?.new_microsite_extra_clt);
    const [timeoutId, setTimeoutId] = useState(null); // State to track timeout ID
    const [hasCalledApi, setHasCalledApi] = useState(false); // State to track if API call has been made
    const captcha_key =
    window.location.origin.includes("spdevmfp") ||
    window.location.origin.includes("localhost")
      ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
      : window.location.origin.includes("sppreprod") ||
        window.location.origin.includes("sptestmfp")
      ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
      : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";
    
    // const handleClose = () => {
    //     setModalIsOpen(false);
    // };
    
    useEffect(() => {
        if (!temp_id) return;
        const timer = handleNavigation("section5");
        return () => clearTimeout(timer);
    }, [temp_id])
    
    // Create a function to process URL that we can reuse
    const processUrl = () => {
        let currentUrl = window?.location?.href?.replace("/website", "");
        if (!currentUrl?.includes("category") && currentUrl?.includes(".com")) {
            currentUrl = currentUrl?.replace(".com", ".com/category");
        } else if(!currentUrl?.includes("category") && currentUrl?.includes(".in")) {
            currentUrl = currentUrl?.replace(".in", ".in/category");
        }
        return currentUrl;
    };

    const previousUrlRef = useRef(processUrl());

    useEffect(() => {
        console.log('CategoryContainer effect run. id:', id, 'search:', location.search);
        window.scrollTo({
            top: 0,
        });
        const startTracking = async () => {
            try {
                const tokenLeader = await microSiteEncrypt();
                if (tokenLeader && tokenLeader !== "") {
                    const now = Date.now();
                    if (lastFetchRef.current.id === id && (now - lastFetchRef.current.time) < 1500) {
                        console.log('Skipping rapid duplicate fetch for id', id);
                    } else {
                        lastFetchRef.current = { id, time: now };
                        console.log('Calling fetchLeaderDetailData for id', id);
                        dispatch(fetchLeaderDetailData(tokenLeader, id));
                    }
                }
            } catch (err) {
                console.error('startTracking error', err);
            }

            setTimeout(() => {
                generateEventAction("start");
            }, 2000);
        };

        // Always call startTracking when `id` changes; startTracking guards against rapid duplicates.
        startTracking();
        intervalRef.current = setInterval(() => {
            generateEventAction("call");
        }, 20000);
        
        return () => {
            clearInterval(intervalRef.current);
            generateEventAction("end");
        };
    }, [id, location.search]);
  
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (!section) return;
        const headerOffset = 89; // Adjust based on the header height
        const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    const handleNavigation = (section) => {
        window.scrollTo({
            top: 0,
        });
        return setTimeout(() => {
            scrollToSection(section)
        }, 1000);
    }
    
    const generateEventAction = async (action) => {
        let tokenEvent = "";
        let url = processUrl();  // Always get the current URL
        
        
        // For "end" action, use the previous URL
        if (action === "end") {
            url = previousUrlRef.current;
        } else {
            // Update the previous URL ref with current URL for next time
            previousUrlRef.current = url;
        }

        let flow = "";
        let contact_id = "";
        if (Cookies.get("new_c")) {
            contact_id = Cookies.get("new_c");
        } else if (Cookies.get("c")) {
            contact_id = Cookies.get("c");
        }
        
        let end_time = new Date();
        tokenEvent = await microSiteEncrypt();
        if (!Cookies.get("vtkn")) {
           Cookies.set("vtkn", tokenEvent); 
        }
        if (tokenEvent && tokenEvent !== "") {
            dispatch(eventTracking(tokenEvent, "", url, action, (action === "call" || action === "end" || action === "idle") ? formatDateToISD(end_time) : "", flow, contact_id));
        }
    };
    
    function formatDateToISD(dateString) {
        const date = new Date(dateString);

        // Helper function to add leading zero
        const padZero = (num) => (num < 10 ? `0${num}` : num);

        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1); // Months are zero-indexed
        const day = padZero(date.getDate());
        const hours = padZero(date.getHours());
        const seconds = padZero(date.getSeconds());
        const minutes = padZero(date.getMinutes());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const handleOnIdle = () => {
        if (!hasCalledApi) {
            console.log("User is idle. Setting up timeout for API call.");

            // Set a timeout to trigger the API call after 10 minutes
            const id = setTimeout(() => {
                console.log("Making API call after 10 minutes of being idle.");
                generateEventAction("idle");
                
                clearInterval(intervalRef.current);
                
                setHasCalledApi(true); // Mark that API call has been made
            }, 10 * 60 * 1000);

            setTimeoutId(id);
        }
    };

    const handleOnActive = () => {
        console.log("User is active.");

        // Reload the page if the API call was already made once
        if (hasCalledApi) {
            console.log("Reloading page since API call was already made once.");
            window.location.reload();
        }

        // Clear the timeout if the user becomes active
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
    };

    // Add siteColors object near the top with other state/refs
    const siteColors = {
        primary: theme_colors.primary,    // Blue color
        secondary: theme_colors.secondary,  // Orange color
        textMuted: "#00000070" // Semi-transparent black
    };

    return (
        <IdleTimerProvider
            timeout={1000}
            onIdle={handleOnIdle}
            onActive={handleOnActive}
        >
            <div className='bg-[#fff]' style={{ marginTop: 'var(--header-height)' }}>
                <div className='lg:max-w-7xl hidden max-sm:block mx-auto'>
                    <DetailProfile banner={profile_data?.banner} colors={siteColors} />
                </div>
                <div className='p-4'>
                    <div className='max-sm:hidden lg:max-w-7xl mx-auto'>
                        <DetailProfile banner={profile_data?.banner} colors={siteColors} />
                    </div>
                    <div className=''>
                        <CategoryDetails detail={profile_data} colors={siteColors} />
                    </div>
                </div>
                {profile_data?.benefits?.length > 0 && <div className='px-12 max-sm:px-4 mt-12 max-sm:mt-4'>
                    <BenefitCarousel benefit={profile_data?.benefits} colors={siteColors} />
                </div>}
                
                <section id='section5' className='px-12 max-sm:px-4 mb-4'>
                    <CategoryList data={profile_data?.case_data} colors={siteColors} />
                </section>

                {profile_data?.faq?.length > 0 && <div className='px-12 max-sm:px-4 my-12'>
                    <FaqAccordion faq={profile_data?.faq} colors={siteColors} />
                </div>}
                
                <section id='section4' style={{ backgroundColor: siteColors.primary }}>
                    <LeadForm colors={siteColors} />
                </section>
                <section id='section7' style={{ backgroundColor: siteColors.primary }} className='bg-[#2167A7]'>
                        <Disclaimer colors={siteColors} microsite_clt={new_microsite_extra_clt} />
                </section>
            </div>
            <WhatsappButton colors={siteColors} />
        </IdleTimerProvider>
    );
};

export default CategoryContainer;
